export default "__VITE_ASSET__CbKvvMx3__"